module.exports = __webpack_public_path__ + "img/logo4.2e9b141c.png";